import { getConfig } from '../envconfig';
import { messagebus } from '../main';
import store from '../store';
import { config } from './Signup-dat';
const uuid = require('uuid/v4');
var PaymentLib = require('payment/lib');
var AmazonCognitoIdentity = require('amazon-cognito-identity-js');
// var devlog = (process.env.NODE_ENV === "production") ? (() => { }) : console.log;
var devlog = (() => { });
// var devlog = console.log;
devlog(" This is Signup-lib.   NodeEnv is " + process.env.NODE_ENV);
const COGNITO_POOL_TPD = 'shoeNJD#394js';

function fieldRequiredTest(value) {
    if (!value) {
        return true;    // True, that there *IS* a problem
    }
    if (typeof value === "object") {
        return false;   // OK if object
    } else if (typeof value === "string") {
        return ((value.length || 0) < 1);   // True problem, if string length 0
    }
    return true;
};
function fieldRequiredProblem(value, fieldName, errExpr) {
    if (!fieldRequiredTest(value)) {
        return null;
    }
    return (errExpr || ("Please provide " + (fieldName || " this field")));
};

// function safeParse(src) {
//     var result = {};
//     try {
//         result = JSON.parse(src);
//     } catch (err) {
//     }
//     return result;
// };


// =================================================================
// validateEmail
// =================================================================
async function validateEmailBegin() {
    const curEmailVal = store.state.signupFormData.email;
    devlog("curEmailVal is " + curEmailVal);
    if (!curEmailVal) {
        // console.log("Bad email foo exit");
        store.commit("EV_LOCK", false);
        messagebus.$emit('doModalError', "You must provide an email address, and then we will be able to start " +
            "the validation process by sending you a verification code.");
        return;
    }
    try {
        //  ## We are removing checkEmailAvailableProactive because we don't want that
        //      service in the public API.  
        //   ** checkEmailAvailable will now only run once the email has been validated.
        //checkEmailAvailableProactive(ctx, curEmailVal);  // Start async email check
        //
        let userPool = await cognitoPool();
        let authUser;

        // -------------------------------------------------------------
        // Step 1.  Start by Trying to Register
        // -------------------------------------------------------------
        const cognitoReply = await tryRegisterCognito({ userPool, email: curEmailVal });
        if (!cognitoReply.UsernameExists) { // Cognito profile for email doesn't exist
            // -------------------------------------------------------------
            // Step 1a. CONF CODE SENT  (This is the "usual" case)
            // -------------------------------------------------------------
            devlog(" cognito step 1a.  Data on sub is: " + cognitoReply.userSub);
            store.commit("COGNITO_PROFILE", { sub: cognitoReply.userSub });
            messagebus.$emit('confDialog');
            return;
        }
        // What do we do when user exists ?
        devlog("User exists, so we'll try to get Session to investigate their status");
        // -------------------------------------------------------------
        // Step 2. Attempt a credentials authentication
        // -------------------------------------------------------------
        const sessionResult = await getCognitoSession({ email: curEmailVal, unAuthOK: true });
        if (sessionResult.UserNotConfirmed) {
            // What do we do when UNCONFIRMED user exists ?   Offer a re-send of code ??
            // -------------------------------------------------------------
            // Step 3. Prompt to RE-SEND a validation code
            // -------------------------------------------------------------
            messagebus.$emit('doResendDialog');
            return;
        }
        // Moving on....  Now we need to get all attributes to see how far they got in FuseBill
        // --------------------------------------------------------------------
        // Step 4. Get accumulated attributes (+custom) from Cognito Profile
        // --------------------------------------------------------------------
        authUser = sessionResult.cognitoUser;
        devlog(" Try to get Attribs ");
        const userAttribs = await new Promise((resolve, reject) => {
            authUser.getUserAttributes(function (err, result) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(result);
            });
        });
        store.commit("EV_LOCK", false);
        // --------------------------------------------------------------------
        // Step 5. Update State with User Attributes
        // --------------------------------------------------------------------
        let cognitoProfileUpdate = {};
        for (let i in userAttribs) {
            cognitoProfileUpdate[userAttribs[i].getName()] = userAttribs[i].getValue();
        }
        store.commit("COGNITO_PROFILE", cognitoProfileUpdate);
        if (cognitoProfileUpdate.email_verified === "true") {
            // --------------------------------------------------------------------
            // Step 6a. Prompt to carry-on with signip process
            // --------------------------------------------------------------------
            await checkEmailAvailable(curEmailVal)
                .then(isAvailable => {
                    if (isAvailable) {
                        messagebus.$emit('doModalInfo', { msg: config.messages.alreadyValidatedNotSigned });
                    }
                });
        }
        // --------------------------------------------------------------------
        // Step 6b. ##TODO##  Prompt that email is "locked" as used
        //  Do we want to offer a "re-do" case if Fusebill has them as "Cancelled"
        // --------------------------------------------------------------------
    } catch (err) {
        store.commit("EV_LOCK", false);
        devlog(" BottomCatch Step1 " + (err.displayMsg || err.message));
        messagebus.$emit('doModalError', (err.displayMsg || err.message));
    }
};

// =================================================================
// resendConfCode
// =================================================================
async function resendConfCode() {
    let curEmailVal = store.state.signupFormData.email;
    devlog("curEmailVal is " + curEmailVal);
    if (!curEmailVal) {
        // console.log("Bad email foo exit");
        messagebus.$emit('doModalError', "You must provide an email address, and then we will be able to start " +
            "the validation process by sending you a verification code.");
        return;
    }
    const userPool = await cognitoPool();
    const cognitoUser = new AmazonCognitoIdentity.CognitoUser({
        Username: curEmailVal.toLowerCase(),
        Pool: userPool
    });
    // ##TODO Promisify ??
    cognitoUser.resendConfirmationCode(function (err, result) {
        if (err) {
            // ##TODO Common catch-all logic as used above ??
            alert(err);
            return;
        }
        // console.log('call result: ' + result);
        // ##TODO Update SUB ??
        messagebus.$emit('doConfDialog');
    });
};


function tryRegisterCognito({ userPool, email }) {
    let ciEmail = (email || "").toLowerCase();
    return new Promise((resolve, reject) => {
        let attributeList = [];
        attributeList.push(new AmazonCognitoIdentity.CognitoUserAttribute({
            Name: 'email',
            Value: ciEmail
        }));
        userPool.signUp(ciEmail, COGNITO_POOL_TPD, attributeList, null, (err, result) => {
            if (err) {  // Error is actually resolvable, in case of UsernameExists
                if (err.code === "UsernameExistsException") {
                    resolve({ UsernameExists: true });
                    return;
                }
                err.customMsg = ("Unable to send validation email. \n" + err.message);
                reject(err);    // Other errors get rejected
                return;
            }
            resolve(result);
        });
    });
};

async function processConfCode(confCode) {
    const email = (store.state.signupFormData.email || '').toLowerCase();
    // console.log(confCode, poolData);
    let userPool = await cognitoPool();
    let cognitoUser = new AmazonCognitoIdentity.CognitoUser({
        Username: email,
        Pool: userPool
    });
    // console.log(cognitoUser);
    return new Promise((resolve, reject) => {
        // Step 1.  Verify Code with Cognito
        cognitoUser.confirmRegistration(confCode, true, (errParam, rsltParam) => {
            store.commit("EV_LOCK", false);
            if (errParam || (!rsltParam)) {
                let displayMsg = ("Unable to validate email. \n" + errParam.message);
                messagebus.$emit('doModalError', displayMsg);
                reject(errParam || {});
                return;
            }
            // *changed following mutation to action so it can call another asynch
            // commit('COGNITO_PROFILE', { email_verified: "true" });
            store.commit("COGNITO_PROFILE", { email_verified: "true" });
            // So at this point, email is verified, but not yet "validated" as confirmed to be also availabled in system
            messagebus.$emit('hideConfDialog');
            // ##QUESTION
            // In theory, should we be retrieving attributes and other things
            //  we do on a resume-path that was already confirmed ??
            resolve();
        });
    }).then(() => {
        // Step 2.  Check email available in DesignDocs
        return checkEmailAvailable(email);
    }).catch(() => ({})); //Errors already handled in each step.
};


// checkEmailAvailable
//  This checks Email Available in DesignDocs.  It must be done with a cognito user that
//  is already confirmed.  It only checks that associated email (the cognito
//      credentials are used to call the API).
function checkEmailAvailable(email) {
    return getCognitoSession({ email })
        .then(({ session }) => {
            const idToken = session.getIdToken().getJwtToken();
            //console.log(`    getCogSession ${idToken} `);
            return messagebus.$http.get(`/api/misc/emailAvailable`, {
                headers: {
                    Authorization: idToken
                }
            });
        }).then(result => {
            console.log("  emailAvail received response: " + JSON.stringify(result));
            const emailAvail = (result.body || {}).available;
            if (emailAvail === "YES") {
                store.commit("COGNITO_PROFILE", { emailIsAvailable: "true" });
                return true;
            } else if (emailAvail === "NO") {
                store.commit("COGNITO_PROFILE", {
                    email_verified: undefined,
                    sub: undefined,
                    emailIsAvailable: undefined
                });
                store.commit("SIGNUP_FORM", { email: undefined });
                messagebus.$emit('doModalError', config.messages.emailDuplicate);
                return false;
            } else {
                devlog("checkEmailAvailable failed...   Asssume OK??");
                store.commit("COGNITO_PROFILE", { emailIsAvailable: "true" });
                return true;
            }
        }).catch(err => {
            devlog(`checkEmailAvailable failed... ${err.message}  Asssume OK?? `);
            devlog(` ${err.stack} `);
            store.commit("COGNITO_PROFILE", { emailIsAvailable: "true" });
            return true;
        });
}

// getCognitoSession
//  This gets a cognito session for a user we expect to be registered and validated
async function getCognitoSession({ email, unAuthOK }) {
    let ciEmail = (email || "").toLowerCase();
    const userPool = await cognitoPool();
    return new Promise((resolve, reject) => {
        let cognitoUser = new AmazonCognitoIdentity.CognitoUser({
            Username: ciEmail,
            Pool: userPool
        });
        let authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails({
            Username: ciEmail,
            Password: COGNITO_POOL_TPD
        });
        devlog(" getCognitorSession Attempt to authrozize : " + JSON.stringify(authenticationDetails));
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function (result) {
                cognitoUser.getSession((err, session) => {
                    if (err) {
                        if ((err.code === "UserNotConfirmedException") && unAuthOK) {
                            resolve({ UserNotConfirmed: true });
                            return;
                        }
                        reject(err);
                        return;
                    }
                    resolve({ session, cognitoUser });
                });
            },
            onFailure: function (err) {
                if ((err.code === "UserNotConfirmedException") && unAuthOK) {
                    resolve({ UserNotConfirmed: true });
                }
                reject(err);
            }
        });
    });
}

async function cognitoPool() {
    const envConfig = await getConfig();
    return new AmazonCognitoIdentity.CognitoUserPool({
        UserPoolId: envConfig.userPoolId,
        ClientId: envConfig.userPoolClientId
    });
}

function submitSignup() {
    const email = store.state.signupFormData.email;
    let cogUser;
    store.commit('SIGNUP_FORM', { "signup-req-id": uuid() });
    getCognitoSession({ email })
        .then(({ session, cognitoUser }) => {
            const idToken = session.getIdToken().getJwtToken();
            cogUser = cognitoUser;
            devlog(" We have an ID token: " + idToken);
            messagebus.$emit('doShowBusy');
            //  ##NOTE: The following block should be commented. Was used for testing idempotency on back-end
            //      to prevent AWS's at-least-once delivery of API requests occasionaly making a duplicate
            //      signup invocation.
            // let fooDupReq = ctx.$http.post(process.env.DAPI_ENDPOINT, ctxState.signupFormData,
            //     {
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'Authorization': idToken
            //         }
            //     });
            // fooDupReq.then(r => {
            //     console.log(" foodup finished ");
            // });
            return messagebus.$http.post(`/api/signup`, store.state.signupFormData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': idToken
                    }
                });
        }).then((result) => {
            devlog("AWS Result: " + JSON.stringify(result));
            // ##Add a constant Success Message here
            messagebus.$emit('doModalInfo', { msg: config.messages.success, redirect: "http://www.designdocs.com" });
        }).catch((err) => {
            devlog("AWS (orNested) Error: " + JSON.stringify(err));
            if (err.stack) {
                console.error('Stack: ', err.stack);
            }
            // Maybe in these error cases can we still log the Event/Trip num from api ??
            if (err.status === 504) {       // API Timeout scenario (but bg signup process might still complete OK
                store.commit('SET_MAIN_PAGE', 2);
                checkSignupCompleteFlag({ cogUser });
            } else if (checkIfErrorShouldBeReported(err)) {
                messagebus.$emit('doModalError', err.body.description);
            } else {
                messagebus.$emit('doModalError', config.messages.catchAllError);
            }
        });
}

function checkIfErrorShouldBeReported(pErr) {
    if (pErr && pErr.body && pErr.body.description) {
        if ((typeof pErr.body.description) === "string") {
            // Check for special Override cases
            if (pErr.body.description.indexOf("The stateId must have a value for the countryId") >= 0) {
                pErr.body.description = "The country you specified also requires a Province/State.";
            }
            return true;
        }
    }
    return false;
}

// checkSignupCompleteFlag
//      This is a loopable callback to check if the signup has completed.  We
//      try to synchronously wait and give a definitive answer, but sometimes
//      the API gateway timesout, and the overall signup result is still success
//      even though it was "errorr" at the api layer.
function checkSignupCompleteFlag({ cogUser }) {
    devlog("Going ot set pause in checker.");
    setTimeout(() => {
        // Call to Check if status is complete
        let cognitoProfileCheck = (new Promise((resolve, reject) => {
            cogUser.getUserAttributes((err, data) => {
                devlog("User Attribs callback");
                if (err) {
                    devlog("    User Attribs Error " + (err.stack || ' '));
                    reject(err);
                    return;
                }
                devlog("    User Attribs Resolved ");
                resolve(data);
            });
        }));
        cognitoProfileCheck.then((result) => {
            devlog("    User Attribs THEN THEN ");
            // All is good now
            if (getCognitoUserAttrib(result, "custom:sysb_activate_ts")) {
                devlog("    Timestamp Ha been FUNF");
                store.commit('SET_TIMEOUT_COMPLETE', true);
            } else {
                devlog("No ts -> loop around");
                checkSignupCompleteFlag({ cogUser });
            }
        }).catch(() => {
            // just abort...
        });
    }, 6000);
}

function getCognitoUserAttrib(userRec, attribName) {
    // if (!userRec.UserAttributes) {
    //     console.log("no user attributes");
    //     return null;
    // }
    for (let attrib of userRec) {
        devlog("      checking attrib: " + attrib.Name + " " + JSON.stringify(attrib));
        if (attrib.Name === attribName) {
            return attrib.Value;
        }
    }
    return null;
}

function creditCardErrorMessage(cardData) {
    if (!PaymentLib.fns.validateCardNumber(cardData.number)) {
        return "Card Number is invalid";
    }
    if (!(cardData.name !== '')) {
        return "Card Name must be provided";
    }
    if (!(cardData.expiry !== '')) {
        return "Card expiry must be provided";
    } else if (!(/^((0[1-9])|(1[0-2]))[/](2(0|1)[0-9]{2})$/.test(cardData.expiry))) {
        return "Card expiry must be MM/YYYY";
    }
    let objVal = PaymentLib.fns.cardExpiryVal(cardData.expiry);
    if (!PaymentLib.fns.validateCardExpiry(objVal.month, objVal.year)) {
        return "Card expiry is not valid";
    }
    if (!PaymentLib.fns.validateCardCVC(cardData.cvc, PaymentLib.fns.cardType(cardData.number))) {
        return "Card cvc is invalid";
    }
    let cardType = PaymentLib.fns.cardType(cardData.number);
    if (!["mastercard", "visa"].includes(cardType)) {
        return "Card must be a Mastercard or Visa";
    }
    return false;   // false == No Error
}
function getCardType(cardData) {
    return PaymentLib.fns.cardType(cardData.number);
}

// ---------------------------------------------------------------------------------------------------------------
//      VALIDATIONS
// ---------------------------------------------------------------------------------------------------------------
var validations = {
    validateFirstName: function () { // console.log("Validation looks at: " + val);
        return (fieldRequiredProblem(this.$store.state.signupFormData.firstName, "First Name"));
    },
    validateLastName: function () { // console.log("Validation looks at: " + val);
        return (fieldRequiredProblem(this.$store.state.signupFormData.lastName, "Last Name"));
    },
    validateCompany: function () { // console.log("Validation looks at: " + val);
        return (fieldRequiredProblem(this.$store.state.signupFormData.company, "Company"));
    },
    validateEmail: function () {
        // return false;  // ## DEBUG
        if (this.$store.getters.emailIsValidatedAndAvailable) {
            return false;
        }
        return "You must validate your email address";
    },
    validateCountry: function () {
        return (fieldRequiredProblem(this.$store.state.signupFormData.country, null, "You must select a Country"));
    },
    validateAddr1: function () { // console.log("Validation looks at: " + val);
        return (fieldRequiredProblem(this.$store.state.signupFormData.addr1, "Address"));
    },
    validateCity: function () { // console.log("Validation looks at: " + val);
        return (fieldRequiredProblem(this.$store.state.signupFormData.city, "City"));
    },
    validatePostal: function () { // console.log("Validation looks at: " + val);
        return (fieldRequiredProblem(this.$store.state.signupFormData.postal, "Postal Code"));
    }
};

export {
    fieldRequiredProblem,
    validateEmailBegin,
    processConfCode,
    resendConfCode,
    submitSignup,
    //checkEmailAvailable,
    validations,
    creditCardErrorMessage,
    getCardType,
    devlog,
    getCognitoSession
};



// WEBPACK FOOTER //
// ./src/components/Signup-lib.js